var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-font-inter"},[_c('DesktopMenu',{staticClass:"max-sm:tw-hidden"}),_c('MobileMenuDrawer',{staticClass:"sm:tw-hidden"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }